import { render, staticRenderFns } from "./PageWithSidebar.vue?vue&type=template&id=4a8b2d3c&scoped=true&lang=pug&"
import script from "./PageWithSidebar.vue?vue&type=script&lang=ts&"
export * from "./PageWithSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./PageWithSidebar.vue?vue&type=style&index=0&id=4a8b2d3c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8b2d3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VTab,VTabItem,VTabs})
